import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import { BundleOffer } from '~/services/AccommodationService';

interface Props {
  offers: Array<BundleOffer>;
}

const columns: Array<GridColDef> = [
  {
    field: 'entityType',
    headerName: 'Type',
    width: 130,
    renderCell: ({ value }) => <Chip label={value} size="small" variant="outlined" />,
  },
  {
    field: 'entityId',
    headerName: 'Entity ID',
    flex: 1,
    minWidth: 200,
    valueGetter: (_value, row) => row.entityId ?? '—',
  },
  {
    field: 'propertyId',
    headerName: 'Property ID',
    flex: 1,
    minWidth: 200,
    valueGetter: (_value, row) => row.propertyId ?? '—',
  },
  {
    field: 'price',
    headerName: 'Price',
    width: 120,
    valueGetter: (_value, row) => `${row.currency} ${row.price?.toFixed(2) ?? '0.00'}`,
  },
];

export default function BundleOffersSection({ offers }: Props) {
  if (offers.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No offers associated with this bundle.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        Properties and experiences included in this bundle. Offers are managed via Tags.
      </Typography>
      <DataGrid
        rows={offers}
        columns={columns}
        autoHeight
        disableRowSelectionOnClick
        hideFooter={offers.length <= 10}
        pageSizeOptions={[10]}
      />
    </Stack>
  );
}
